import { createKeyPath } from 'CMFW/context/helper/keyContext';
import KeyContext from 'CMFW/context/KeyContext';
import ModuleContext from 'CMFW/context/ModuleContext';
import { SelectLayout } from 'components/selects/SelectLayout';
import { getCacheKey } from 'helpers/cache';
import { useCacheData } from 'hooks/useCacheData';
import { useCurrentItemValue } from 'hooks/useCurrentItemValue';
import React, { useContext, useMemo } from 'react';
import MemoryMeansTemplateSelectModel, { IMemoryMeansTemplateOption } from 'models/MemoryMeansTemplateSelectModel';
import { IRefIds } from 'constants/refs';

type IProps = {
  keyName: 'em1_bank_item_id' | 'em2_bank_item_id' | 'em3_bank_item_id';
  label: string;
  emCount: 1 | 2 | 3;
};

const MemoryMeansTemplateSelect: React.FC<IProps> = ({ keyName, label, emCount }) => {
  const module = useContext(ModuleContext);
  const parentKey = useContext(KeyContext);
  const aggregatedKeyName = createKeyPath(parentKey, keyName);

  const moduleItemValue = (module.getItemValue.bind(module)(aggregatedKeyName) || 0) as number;
  const [currentValue, setCurrentValue] = useCurrentItemValue<number>(moduleItemValue, 0, true);
  const originalValue = moduleItemValue;

  const cacheKey = getCacheKey(IRefIds.bankParagraph, emCount, 0);
  const dataModel = useMemo(() => new MemoryMeansTemplateSelectModel(), []);
  const cacheSelectData = useCacheData(cacheKey, () => dataModel.get(emCount));

  const selectData = useMemo(() => {
    if (cacheSelectData === null) return null;
    return (cacheSelectData as IMemoryMeansTemplateOption[]).map((opt) => ({
      id: opt.id,
      label: `${opt.id} – ${opt.label}`,
    }));
  }, [cacheSelectData]);

  const handleChange = (value: { id: number }) => {
    setCurrentValue(value.id);
    module.updateItemValue.bind(module)(aggregatedKeyName, value.id);
  };

  return (
    <SelectLayout
      data={selectData}
      onChange={handleChange}
      label={label}
      optionLabelKey="label"
      currentValue={currentValue}
      originalValue={originalValue}
      optionValueKey="id"
    />
  );
};

export default MemoryMeansTemplateSelect;
